export default __webpack_public_path__ + "static/media/world.f69f1142.svg";